import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileMarkdownTwoToneSvg from "@ant-design/icons-svg/es/asn/FileMarkdownTwoTone";
import AntdIcon from '../components/AntdIcon';
var FileMarkdownTwoTone = function FileMarkdownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FileMarkdownTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FileMarkdownTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FileMarkdownTwoTone';
}
export default RefIcon;